<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-tab`]" width="1em" height="1em" v-bind="$attrs"><path d="M14.3047 4.07349L14.3047 9.2793" stroke="#00BBD8" stroke-width="1.66" stroke-linecap="round"/><path d="M20.8196 9.44585V15.1264C20.8196 16.8065 20.8196 17.6466 20.4926 18.2883C20.205 18.8528 19.746 19.3118 19.1816 19.5994C18.5398 19.9264 17.6997 19.9264 16.0196 19.9264H7.98164C6.30148 19.9264 5.4614 19.9264 4.81967 19.5994C4.25518 19.3118 3.79624 18.8528 3.50862 18.2883C3.18164 17.6466 3.18164 16.8065 3.18164 15.1264V9.44585M20.8196 9.44585V8.87349C20.8196 7.19333 20.8196 6.35325 20.4926 5.71151C20.205 5.14703 19.746 4.68809 19.1816 4.40047C18.5398 4.07349 17.6997 4.07349 16.0196 4.07349H13.147H7.98164C6.30148 4.07349 5.4614 4.07349 4.81967 4.40047C4.25518 4.68809 3.79624 5.14703 3.50862 5.71151C3.18164 6.35325 3.18164 7.19333 3.18164 8.87349V9.44585M20.8196 9.44585H3.18164" stroke="#165DFF" stroke-width="1.66" stroke-linecap="round" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconColorTab',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
